import type { ActionButtonProps } from '../../components/commandActions/types'
import { AnnotationCommand } from './AnnotationCommand'

export const LifeAnnotationCommand = (props: ActionButtonProps) => (
  <AnnotationCommand {...props} festinaComponent="life" />
)
